export enum ConnectionStatus {
  Offline = 0,
  IoTOnly = 1,
  Online = 2,
}
